import { useEffect, useRef, useState } from "react";
import testimonial1 from "../../assets/Testimonial1.png";
import testimonial2 from "../../assets/Testimonial2.png";
import testimonial3 from "../../assets/Testimonial3.png";
import testimonial4 from "../../assets/Testimonial4.png";
import testimonial5 from "../../assets/Testimonial5.png";
import testimonial6 from "../../assets/Testimonial6.png";

const testimonials = [
  {
    id: "1",
    quote:
      "My son is in Grade 12 and plays state-level cricket. Regular school was getting impossible because of his daily practice and matches. Altus has been a lifesaver for us. The admission team was so polite and explained the flexible timing clearly. Since he misses a lot of morning classes, his teachers are very kind and arrange extra evening classes for him. His studies and his game are finally balanced.",
    name: "Suresh K.",
    detail: "Aarav's father",
    initials: "SK",
    avatarSrc: testimonial1,
    avatarAlt: "Man wearing black and white top",
  },
  {
    id: "2",
    quote:
      "Our daughter is in Grade 9 and has a minor concentration problem. She used to get completely lost in a physical classroom of 40 kids. Moving to Altus changed everything. The teachers give her so much personal attention. If she gets distracted or misses a test, they patiently take an extra doubt session for her without making her feel bad. The whole admission process was very smooth, and the teachers really understood our situation",
    name: "Neha & Rahul M.",
    detail: "Tanvi's parents",
    initials: "N&R",
    avatarSrc: testimonial2,
    avatarAlt: "Neha and Rahul M.",
  },
  {
    id: "3",
    quote:
      "I was really struggling with the heavy pressure of the IB curriculum and was constantly stressed out. My parents and I took a big chance and shifted my board to NIOS through Altus. It was honestly the best decision we ever made! The counselor at their Mumbai office was incredibly helpful and guided me through the whole transition. The teachers gave me extra classes to help me catch up, which completely rebuilt my confidence. Thanks to my good grades at Altus, I just got accepted into NYU!",
    name: "Anjali R.",
    detail: "New York University (NYU)",
    initials: "AR",
    avatarSrc: testimonial3,
    avatarAlt: "Anjali R.",
  },
  {
    id: "4",
    quote:
      "We were in pure panic when my son didn't clear his A-Levels. We thought his whole year was wasted. A counselor friend told us about Altus. The admission team moved fast to get him enrolled. The teachers prepared him in just 20 days for the exact same subjects! He passed his Grade 12 exams and saved his year, we also got the college we wanted. We are so thankful to the teachers for working overtime with him.",
    name: "Priya T.",
    detail: "Panav's mother",
    initials: "PT",
    avatarSrc: testimonial4,
    avatarAlt: "Priya T.",
  },
  {
    id: "5",
    quote:
      "I am pursuing acting, I also go to an acting school, and my shooting schedules are completely sudden. A traditional school routine was just not working for me. Joining Altus was the best decision for my education. I had a flexible study routine. The teachers are super supportive. Whenever I miss my regular classes because of a shoot, they happily arrange extra backup classes for me. It has been a very smooth experience.",
    name: "Ahad A.",
    detail: "NMIMS, Mumbai",
    initials: "AA",
    avatarSrc: testimonial5,
    avatarAlt: "Ahad A.",
  },
  {
    id: "6",
    quote:
      "My son’s dream is to become a commercial pilot, but he didn't take Physics in his ICSE board. We thought his dream was over until the Altus team told us he could do just a single subject (Physics) with them. The admission staff guided us. The teachers were fantastic; they gave him extra tests and attention to clear his basic concepts. Because of Altus, he is now enrolled in a top aviation academy!",
    name: "Vikram D",
    detail: "Viren's father",
    initials: "VD",
    avatarSrc: testimonial6,
    avatarAlt: "Vikram D",
  },
];

function TestimonialCard({ quote, name, detail, initials, avatarSrc, avatarAlt }) {
  return (
    <figure className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/[0.06] sm:p-7">
      <blockquote className="min-w-0 flex-1">
        <p className="text-pretty text-sm leading-relaxed text-ink/80 sm:text-[0.9375rem]">
          &ldquo;{quote}&rdquo;
        </p>
      </blockquote>
      <figcaption className="mt-6 flex items-center gap-3 border-t border-brand/10 pt-5">
        {avatarSrc ? (
          <img
            src={avatarSrc}
            alt={avatarAlt ?? ""}
            className="h-11 w-11 shrink-0 rounded-lg object-cover sm:h-12 sm:w-12"
            width={48}
            height={48}
            loading="lazy"
          />
        ) : (
          <span
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-brand/10 text-xs font-bold tracking-tight text-brand sm:h-12 sm:w-12 sm:text-sm"
            aria-hidden
          >
            {initials}
          </span>
        )}
        <cite className="min-w-0 flex-1 not-italic">
          <span className="block font-bold text-ink">{name}</span>
          <span className="mt-0.5 block text-sm text-ink/60">{detail}</span>
        </cite>
      </figcaption>
    </figure>
  );
}

function HomeStudentsTestimonials({ backgroundClassName = "bg-[#f0f0f0]" }) {
  const sliderRef = useRef(null);
  const [activeDot, setActiveDot] = useState(0);
  const [dotCount, setDotCount] = useState(testimonials.length);

  const getSlideMetrics = () => {
    const slider = sliderRef.current;
    if (!slider) return null;

    const firstSlide = slider.firstElementChild;
    const gap = parseFloat(getComputedStyle(slider).gap || "0");
    const step = firstSlide
      ? firstSlide.getBoundingClientRect().width + gap
      : slider.clientWidth;

    const maxScrollLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
    const visibleCards = step > 0 ? Math.max(1, Math.round(slider.clientWidth / step)) : 1;
    const maxStartIndex = Math.max(0, testimonials.length - visibleCards);

    return { slider, step, maxScrollLeft, maxStartIndex };
  };

  const updateDots = () => {
    const metrics = getSlideMetrics();
    if (!metrics) return;

    const { slider, step, maxStartIndex } = metrics;
    const currentIndex = step > 0 ? Math.round(slider.scrollLeft / step) : 0;

    setDotCount(maxStartIndex + 1);
    setActiveDot(Math.max(0, Math.min(currentIndex, maxStartIndex)));
  };

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return undefined;

    updateDots();

    slider.addEventListener("scroll", updateDots, { passive: true });
    window.addEventListener("resize", updateDots);

    return () => {
      slider.removeEventListener("scroll", updateDots);
      window.removeEventListener("resize", updateDots);
    };
  }, []);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      const slider = sliderRef.current;
      if (!slider) return;

      const firstSlide = slider.firstElementChild;
      const gap = parseFloat(getComputedStyle(slider).gap || "0");
      const step = firstSlide
        ? firstSlide.getBoundingClientRect().width + gap
        : slider.clientWidth;

      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const edgeTolerance = 8;

      if (slider.scrollLeft >= maxScrollLeft - edgeTolerance) {
        slider.scrollTo({ left: 0, behavior: "smooth" });
        return;
      }

      slider.scrollTo({
        left: Math.min(slider.scrollLeft + step, maxScrollLeft),
        behavior: "smooth",
      });
    }, 4000);

    return () => window.clearInterval(intervalId);
  }, []);

  const scrollSlides = (direction) => {
    const metrics = getSlideMetrics();
    if (!metrics) return;

    const { slider, step, maxScrollLeft } = metrics;
    const nextScrollLeft = slider.scrollLeft + direction * step;
    const edgeTolerance = 8;

    if (direction > 0 && slider.scrollLeft >= maxScrollLeft - edgeTolerance) {
      slider.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }

    if (direction < 0 && slider.scrollLeft <= edgeTolerance) {
      slider.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
      return;
    }

    slider.scrollTo({
      left: Math.max(0, Math.min(nextScrollLeft, maxScrollLeft)),
      behavior: "smooth",
    });
  };

  const scrollToDot = (index) => {
    const metrics = getSlideMetrics();
    if (!metrics) return;

    const { slider, step, maxScrollLeft } = metrics;
    slider.scrollTo({
      left: Math.min(index * step, maxScrollLeft),
      behavior: "smooth",
    });
  };

  return (
    <section
      className={`relative ${backgroundClassName} py-16 sm:py-20 lg:py-24`}
      aria-labelledby="home-students-testimonials-heading"
    >
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
        <header className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
            Student voices
          </p>
          <h2
            id="home-students-testimonials-heading"
            className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:mt-5 sm:text-4xl md:text-[2.375rem] md:leading-tight"
          >
            Students Testimonials
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-pretty text-base leading-relaxed text-ink/65 sm:mt-5 sm:text-lg">
            Hear from learners and families who chose a school that adapts to real life—not the other way around.
          </p>
        </header>

        <div className="mt-12 sm:mt-14">
          <div className="relative overflow-visible lg:px-10">
            <button
              type="button"
              onClick={() => scrollSlides(-1)}
              className="absolute -left-2 top-1/2 z-10 hidden h-10 w-10 -translate-x-full -translate-y-1/2 items-center justify-center rounded-full border border-brand/20 bg-white text-brand shadow-sm transition hover:bg-brand/5 lg:inline-flex"
              aria-label="Show previous testimonials"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                className="h-5 w-5"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button
              type="button"
              onClick={() => scrollSlides(1)}
              className="absolute -right-2 top-1/2 z-10 hidden h-10 w-10 translate-x-full -translate-y-1/2 items-center justify-center rounded-full border border-brand/20 bg-white text-brand shadow-sm transition hover:bg-brand/5 lg:inline-flex"
              aria-label="Show next testimonials"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                className="h-5 w-5"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 6l6 6-6 6" />
              </svg>
            </button>

            <div
              ref={sliderRef}
              className="flex snap-x snap-mandatory gap-6 overflow-x-auto scroll-smooth pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden md:gap-7 lg:gap-8"
            >
              {testimonials.map((t) => (
                <div
                  key={t.id}
                  className="w-full shrink-0 snap-start md:w-[calc((100%-1.75rem)/2)] lg:w-[calc((100%-4rem)/3)]"
                >
                  <TestimonialCard {...t} />
                </div>
              ))}
            </div>
          </div>
          <div className="mt-6 flex justify-center gap-2">
            {Array.from({ length: dotCount }).map((_, index) => (
              <button
                key={`testimonial-dot-${index}`}
                type="button"
                onClick={() => scrollToDot(index)}
                className={`h-2.5 w-2.5 rounded-full transition ${
                  index === activeDot ? "bg-brand" : "bg-brand/25 hover:bg-brand/45"
                }`}
                aria-label={`Go to testimonial slide ${index + 1}`}
                aria-current={index === activeDot ? "true" : undefined}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeStudentsTestimonials;
